import { AcceptPersonalInviteResponse, PersonalInvite } from '../stores/types/invites.interface';
import { API_KEYS, Api } from './base.api';
import { SCOPE_TYPE } from './utils';

export const personalInviteApi = Api.injectEndpoints({
  endpoints: (builder) => ({
    fetchPersonalInvites: builder.query<PersonalInvite[], void>({
      query: () => ({
        url: `/internal/core/v2/${API_KEYS.INVITES}`,
        method: 'GET',
        params: { scope: SCOPE_TYPE.NONE },
        needCompanyId: false,
      }),
      transformResponse: (response: PersonalInvite[]) => {
        return response.map((invite) => ({
          ...invite,
          dateRequested: new Date(invite.dateRequested),
        }));
      },
      providesTags: () => [{ type: API_KEYS.PERSONAL_INVITES, id: 'LIST' }],
    }),
    acceptPersonalInvites: builder.mutation<AcceptPersonalInviteResponse, string[]>({
      query: (inviteIds) => ({
        url: `/internal/core/v2/${API_KEYS.INVITES}/accept`,
        body: { inviteIds },
        method: 'POST',
        params: { scope: SCOPE_TYPE.NONE },
        needCompanyId: false,
      }),
      invalidatesTags: () => [{ type: API_KEYS.PERSONAL_INVITES, id: 'LIST' }],
    }),
    declinePersonalInvites: builder.mutation<void, string[]>({
      query: (inviteIds) => ({
        url: `/internal/core/v2/${API_KEYS.INVITES}`,
        body: { inviteIds },
        method: 'DELETE',
        params: { scope: SCOPE_TYPE.NONE },
        needCompanyId: false,
      }),
      invalidatesTags: () => [{ type: API_KEYS.PERSONAL_INVITES, id: 'LIST' }],
    }),
  }),
});

export const {
  useFetchPersonalInvitesQuery,
  useAcceptPersonalInvitesMutation,
  useDeclinePersonalInvitesMutation,
} = personalInviteApi;
